import axios from 'axios'
import _ from 'lodash'
import yn from 'yn'
import { clientIds } from '../configuration/brand'

const DolliHTTP = axios.create({
  header: { Accept: 'application/ld+json' },
  params: process.env.REACT_APP_ENABLE_DOLLI_CACHE_BUSTING && yn(process.env.REACT_APP_ENABLE_DOLLI_CACHE_BUSTING)
    ? { provider: 1, cache: new Date().getTime() }
    : { provider: 1 },
})

const endpoints = {
  configuration: process.env.REACT_APP_ENDPOINT_DOLLI + '/config?',
  accommodation:
    process.env.REACT_APP_ENDPOINT_DOLLI + '/content/accommodations',
}

export const configuration = (query) => {
  return axios.get(endpoints.configuration + query.toString())
}

export const accommodation = async (brand, id) => {
  if (!id) return null

  const clientId = clientIds[brand]
  const response = await DolliHTTP.get(`${endpoints.accommodation}/${id}`, {
    params: { brand, clientId },
  })

  return _.get(response, 'data.hydra:member[0]')
}

export default endpoints
